import { useEffect, useState } from 'react';
import { getInvoiceOnFileChargeValidation } from '../api/validationsAPI';
function useGetOnFileChargeValidation({
  invoiceId,
  skip,
  onFailure
}) {
  const [loading, setLoading] = useState(Boolean(invoiceId && !skip));
  const [onFileChargeValidationData, setOnFileChargeValidationData] = useState();
  const resetOnFileChargeValidationData = () => setOnFileChargeValidationData(undefined);
  useEffect(() => {
    if (invoiceId && !skip && onFileChargeValidationData === undefined) {
      getInvoiceOnFileChargeValidation(invoiceId).then(invoiceOnFileValidationMessages => {
        if (invoiceOnFileValidationMessages.length === 0) {
          setOnFileChargeValidationData(null);
        } else {
          setOnFileChargeValidationData(invoiceOnFileValidationMessages[0]);
        }
      }).catch(error => {
        onFailure(error);
      }).finally(() => setLoading(false));
    }
  }, [invoiceId, skip, onFileChargeValidationData, onFailure]);
  return {
    loading,
    onFileChargeValidationData,
    resetOnFileChargeValidationData
  };
}
export default useGetOnFileChargeValidation;